import { FieldSchema } from "../../../Schema";
import { EntryTypes } from "./entryType";

/**
 * What the pending review will do to the record once it is signed.
 *
 * Part of the four-eyes workflow, written by manageProposedChanges rather than by an edit.
 * It is not a change a reviewer is asked to approve, so it is excluded from the reported
 * diff by `AUDIT_NOT_REQUIRED_FIELDS` rather than by being left out of the schema.
 */
export const reviewAction: FieldSchema = {
  name: "reviewAction",
  dataTransform: {
    toGraphql: {
      getter: ({ entryType, reviewAction }) => {
        if ([
          EntryTypes.CLUSTER_SUBEQUIPMENT,
          EntryTypes.STANDALONE_EQUIPMENT
        ].includes(entryType as EntryTypes)) {
          return reviewAction;
        }
        return undefined;
      },
      fields: ["entryType", "reviewAction"]
    },
  },  
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Review action", disabled: true, displayed: false },
};
